<section class="page-section portfolio" id="portfolio">
  <div class="container">
    <div class="row justify-content-center text-center">
      <div *ngFor="let item of portfolioItems$ | async" class="{{disposition}}">
        <app-portfolio-item [data]="item"></app-portfolio-item>
      </div>
    </div>
  </div>
</section>
